import { LoadingDotsIcon } from "mds/icons";

/**
 * A user arriving at /home/ will be redirected to /home/instructor, /home/admin, or /home/student
 * depending on their role. The navigation logic is handled in the Observers component.
 */
export default function Page() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <LoadingDotsIcon />
    </div>
  );
}
